import SocialLink from './SocialLink';

export default SocialLink;


// WEBPACK FOOTER //
// ./src/components/SocialLink/index.js